/* eslint-disable */
import React from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import Faan from 'assets/img/faan_logo.png';
import { Link } from 'react-router-dom';
import "../landing.css"
import Authorization from "../component/Authorization";
import Settings from "@material-ui/icons/SettingsApplications";

const MyComponent = ({classes, user, styles}) => {
    const props_ = {
        styles: styles,
        user: user,
        classes: classes
    };

    return (
        <div className={`root ${classes.root}`}>
            <div className={classes.rootOverlay}>

                <Authorization {...props_}/>

                <Grid container className={classes.center2}>
                    <Grid item lg={6} sm={12}>
                        <div style={{ margin: '15px 0 20px' }}><img src={Faan} /></div>
                    </Grid>
                </Grid>
                <Grid container className={classes.center2} style={{ paddingTop: '0', textAlign: 'center'}}>
                    <Grid item lg={4} sm={12} className={classes.card}>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center">
                            <Card chart>
                                <Link to="/app/settings" className={'animate-card-container'}>
                                    <CardHeader color="success" className={'animate-card-header'}>
                                        <div style={{textAlign: "center", margin: "0"}}>
                                            <Settings style={{fontSize: "60px"}}/>
                                        </div>
                                        <h4 style={styles.title}>Setting </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <p style={{color: '#000'}}>
                                            Module settings
                                        </p>
                                        <Button
                                            type="button"
                                            color="primary"
                                            // style={{background: '#23c3d6'}}
                                        >
                                            Explore
                                        </Button>
                                    </CardBody>
                                </Link>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div >
    );
};

export default MyComponent;



// WEBPACK FOOTER //
// ./src/layouts/Landing/roles/admin.js